import React from "react";
import PropTypes from "prop-types";
import { darkSkyBlue, lightSealBlue, lightestGray, red } from "@govlaunch/palette";

import translatePropsIntoHeight from "../measure/translatePropsIntoHeight";

export default function SelectInput({ children, disabled, isOpen, validationState, css, native, ...props }) {
  if (native) {
    return (
      <select
        css={{
          width: "100%",
          borderRadius: 4,
          boxSizing: "border-box",
          backgroundColor: "#ffffff",
          border: `solid 1px ${lightSealBlue}`,
          cursor: "pointer",
          outline: 0,
          fontSize: 14,
          lineHeight: 1.14,
          height: translatePropsIntoHeight(props),
          paddingLeft: 20,
          paddingRight: 20,
          "&:active, &:focus": {
            border: `solid 1px ${darkSkyBlue}`,
          },
          userSelect: "none",
          ...disabledStyles(disabled),
          ...validationStateStyles(validationState),
          ...css,
        }}
        {...props}
      >
        {children}
      </select>
    );
  }

  return (
    <button
      type="button"
      css={{
        position: "relative",
        display: "flex",
        alignItems: "center",
        width: "100%",
        borderRadius: 4,
        boxSizing: "border-box",
        backgroundColor: "#ffffff",
        border: `solid 1px ${lightSealBlue}`,
        cursor: "pointer",
        outline: 0,
        lineHeight: 1.14,
        height: translatePropsIntoHeight(props),
        paddingLeft: 20,
        paddingRight: 20,
        "&:active, &:focus": {
          border: `solid 1px ${darkSkyBlue}`,
        },
        userSelect: "none",
        ...disabledStyles(disabled),
        ...openStyles(isOpen),
        ...validationStateStyles(validationState),
        ...css,
      }}
      {...props}
    >
      {children}
    </button>
  );
}

SelectInput.propTypes = {
  children: PropTypes.any.isRequired,
  disabled: PropTypes.bool,
  isOpen: PropTypes.bool,
  validationState: PropTypes.string,
  css: PropTypes.object,
  native: PropTypes.bool,
};

SelectInput.defaultProps = {
  disabled: false,
  isOpen: false,
  validationState: null,
  css: {},
  native: false,
};

function disabledStyles(disabled) {
  if (disabled) {
    return {
      pointerEvents: "none",
      backgroundColor: lightestGray,
      border: "solid 1px transparent",
      cursor: "default",
    };
  }
}

function openStyles(isOpen) {
  if (isOpen) {
    return {
      border: `solid 1px ${darkSkyBlue}`,
      "&:focus, &:active": {
        borderBottom: "solid 1px transparent",
      },
      borderBottom: "solid 1px transparent",
      borderBottomLeftRadius: 0,
      borderBottomRightRadius: 0,
    };
  }
}

function validationStateStyles(validationState) {
  if (validationState === "error") {
    return {
      borderColor: red,
    };
  }
}
